<template>
  <div class="app-header">
    <div class="flex items-center justify-between">
      <div class="flex items-center" v-if="selectedTab.indexOf('Tax')<0">
        <app-header-account-sets class="ml-10px"/>
        <div v-if="currentAccountSets">
          <DatePicker v-model="currentAccountDate" :option="dateOption" @change="selectAccountDate"
                      format="yyyy年MM月" type="month" :clearable="false" style="height:34px" @click="handleClick"></DatePicker>
        </div>
        <div v-if="currentAccountSets && statusStr" style="margin-left: 5px;">
          <Tag :color="statusStrColor" >{{statusStr}}</Tag>
        </div>
      </div>
        <div v-else class="flex items-center"></div>
      <div class="flex items-center">
        <div v-if="currentAccountSets" class="remark-btn" @click="showRemark()">
          <i class="h-icon-message"></i>
          <span>备注</span>
        </div>
        <i v-if="webConfig.qrCode" class="fi fi-kf w-20px h-20px text-hover" @click="showKf()" style="margin-left: 20px;"></i>
        <i class="fi fi-bz w-20px h-20px text-hover mx-20px" @click="showAbout()"></i>
<!--        <div class="app-header-info mr-16px">-->
<!--          <DropdownMenu className="app-header-dropdown" offset="0,5" :width="150" placement="bottom-end" :datas="infoMenu" @clickItem="trigger">-->
<!--            <Avatar :src="avatarUrl" :width="30"><span>{{ User.realName }}</span></Avatar>-->
<!--          </DropdownMenu>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import {defineAsyncComponent, h} from 'vue';
import {mapGetters, mapState,mapMutations} from 'vuex';
import manba from 'manba';
import AppHeaderAccountSets from "./modules/app-header-account-sets";
import {layer} from "@layui/layer-vue";
import Renewal from "@/views/app/Renewal";
import setting from "@api/setting";
import checkout from "@api/checkout";
import About from "@/views/About.vue";
import KeFu from "@/views/KeFu.vue";
import {notice, message} from "heyui.ext";
import common from "@api/common";
import RemarkModal from "./modules/RemarkModal.vue";

export default {
  components: {
    AppHeaderAccountSets
  },
    props: {
        selectedTab: String,
    },
  data() {
    return {
      checkYear:0,
      updateCheckYear:0,
      finishCheckout:[],
      searchText: '',
      currentAccountDate: null,
      startDate:null,
      endDate:null,
      infoMenu: [
        {key: 'PersonalSetting', title: '账号信息', icon: 'h-icon-user', height: '430px'},
        {key: 'ChangePassword', title: '修改密码', icon: 'h-icon-lock', height: '430px'},
        // {key: 'ChangePhoneNumber', title: '账号变更', icon: 'h-icon-link', height: '430px'},
        {key: 'AiConfig', title: 'AI配置', icon: 'h-icon-setting', height: '350px'},
        {key: 'logout', title: '退出登录', icon: 'h-icon-outbox'}
      ],
      dateOption:{
        start:null,
        end:null,
      },
      statusStr:'',
      statusStrColor:'green',
      remarkContent: '',
    };
  },
  computed: {
    ...mapState(['User', 'currentAccountSets', 'webConfig']),
    ...mapGetters(['checkoutList']),
    sliderCollapsed: {
      get() {
        return this.$store.state.sliderCollapsed;
      },
      set(value) {
        this.$store.commit('updateSliderCollapse', value);
      }
    },
    accountDate() {
      return this.currentAccountSets ? manba(this.currentAccountSets.currentAccountDate).format("YYYY年MM月") : null;
    },
    avatarUrl() {
      return this.User.avatarUrl || '/images/yun.png'
    },
    dOp() {
      let filter = this.checkoutList.filter(val => val.status !== 2);
      return {
        start: filter[filter.length - 1].checkDate,
        end: filter[0].checkDate,
      }
    }
  },
  watch: {
      selectedTab(){
          checkout.list().then(({data}) => {
              if(data.length!=this.User.checkoutList.length){
                  this.$store.dispatch('init');
              }
          });
      },
    accountDate() {
      this.currentAccountDate = this.accountDate;
      this.dateOption.start = this.currentAccountSets ? manba(this.currentAccountSets.enableDate).format("YYYY-MM-dd") : null;
      if(this.User.checkoutList && this.User.checkoutList.length >0){
        this.dateOption.end = this.User.checkoutList ? manba(this.User.checkoutList[0].checkDate).format("YYYY-MM-dd") : null;
      }else{
        this.dateOption.end = this.currentAccountSets ? manba(this.currentAccountSets.currentAccountDate).format("YYYY-MM-dd") : null;
      }
    }
  },
  mounted() {
    this.currentAccountDate = this.accountDate;
    this.dateOption.start = this.currentAccountSets ? manba(this.currentAccountSets.enableDate).format("YYYY-MM-dd") : null;
    if(this.User.checkoutList && this.User.checkoutList.length >0){
      this.dateOption.end = this.User.checkoutList ? manba(this.User.checkoutList[0].checkDate).format("YYYY-MM-dd") : null;
    }else{
      this.dateOption.end = this.currentAccountSets ? manba(this.currentAccountSets.currentAccountDate).format("YYYY-MM-dd") : null;
    }
    if (this.currentAccountSets && this.currentAccountSets.effectiveDate) {
      let day = manba(this.currentAccountSets.effectiveDate).distance(manba(), manba.DAY);
      if (day >= 0) {
        if (day < 15) {
          notice({
            type: 'warn',
            title: "续期提醒",
            content: `您当前账套将于 <b class="red-color">${day + 1}天</b> 后过期<br/>请及时联系客服续期～`,
            timeout: 0,
            buttons: [
              {
                name: '续期',
                style: 'primary',
                type: 'confirm'
              }
            ],
            events: {
              confirm: e => {
                this.doRenewal()
                e.close();
              }
            }
          });
        }
      } else {
        notice({
          type: 'error',
          title: "过期提醒",
          content: `您当前账套已过期，请联系客服续期～`,
          timeout: 0,
          buttons: [
            {
              name: '续期',
              style: 'primary',
              type: 'confirm'
            }
          ],
          events: {
            confirm: e => {
              this.doRenewal()
              e.close();
            }
          }
        });
      }
    }
    this.getFinishCheckoutDate();
  },
  methods: {
    ...mapMutations(['changeTab', 'newTab', 'updateTabs']),
    selectAccountDate(date){
      let curDate = manba(date, "YYYY年MM月").startOf(manba.MONTH).format("YYYY-MM-dd");
      for(let obj of this.User.checkoutList){
        if(curDate == obj.checkDate && obj.status ==2){
          this.statusStr = '已结账';
          this.$store.commit('updateCurrentAccountDateStatus', '已结账');
          break;
        }else{
          this.statusStr = '';
          this.$store.commit('updateCurrentAccountDateStatus', null);
        }
      }
      this.$store.commit('updateCurrentAccountDate', curDate);
      this.updateTabs([{
        key: "Home",
        title: "首页",
        icon: 'fi fi-home'
      }]);
      this.$store.commit('refreshTab', {key: 'Home', title: "首页"})
    },
    trigger(data) {
      if (data === 'logout') {
        common.logout().then(() => {
          window.location.replace("/");
        });
      } else {
        const find = this.infoMenu.find(val => val.key === data);
        layer.open({
          title: find.title,
          shadeClose: false,
          zIndex: 999,
          area: ['600px', find.height],
          content: h(defineAsyncComponent(() => import('@/views/personal/' + data + '.vue')))
        });
      }
    },
    showAbout() {
      layer.open({
        title: "关于" + this.webConfig.name,
        zIndex: 999,
        area: ['570px', 'auto'],
        content: h(About)
      });
    },
    showKf() {
      layer.open({
        title: "联系客服",
        zIndex: 999,
        area: ['400px', '300px'],
        content: h(KeFu)
      });
    },
    doRenewal() {
      const layerId = layer.open({
        title: "账套续期",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['500px', 'auto'],
        content: h(Renewal, {
          onClose() {
            layer.close(layerId);
          },
          onSuccess() {
            layer.close(layerId);
          }
        })
      });
    },
    accountDateChange(val) {
      let date = manba(val.replace("年", "-").replace("月", "-") + "01").format();
      setting.accountSets.updateCurrentAccountDate(date).then(() => {
        this.$store.dispatch('init');
      })
    },

    handleClick(){
      // 禁止特定元素点击
      const disableElementClick = (selector) => {
        const element = document.querySelector(selector);
        if (element) {
          element.style.pointerEvents = 'none'; // 禁止点击
        }
      };

      // 包装更新逻辑
      const updateElement = (date, currentDate) => {
        const dateStr = this.getMonthNameFromDate(new Date(date.checkDate.replace(' ', 'T')));
        const element = document.querySelector(`span[string='${date.checkDate}']`);
        if (element) {
          // 包裹内容的容器
          const wrapper = document.createElement('div');
          wrapper.style.display = 'inline-flex';
          wrapper.style.flexDirection = 'column';
          wrapper.style.alignItems = 'center';
          wrapper.style.justifyContent = 'center';

          // 克隆文字内容
          const textNode = document.createElement('span');
          textNode.textContent = dateStr;
          textNode.style.lineHeight = '1';

          // 清空原内容并插入新内容
          element.textContent = '';
          element.style.position = 'relative';
          element.appendChild(wrapper);
          wrapper.appendChild(textNode);
          // 添加打钩符号
          const tick = document.createElement('span');
          tick.textContent = '✔';
          tick.style.color = date.checkDate === currentDate + ' 00:00' ? 'white' : '#169516';
          tick.style.lineHeight = '1';
          tick.style.fontSize = '12px';
          tick.style.marginTop = '3px';
          wrapper.appendChild(tick);
        }
      };

      // 禁止点击
      disableElementClick('.h-date-header-show');

      // 检查并更新日历元素
      if (this.finishCheckout && this.finishCheckout.length > 0) {
        const currentDate = this.$store.state.currentAccountSets.currentAccountDate;
        this.finishCheckout.forEach((date) => updateElement(date, currentDate));
      }
      const rightButton = document.querySelector('span.h-date-year-right-picker');
      // 检查元素是否存在
      if (rightButton) {
        // 添加点击事件监听
        rightButton.addEventListener('click', () => {
          this.updateCheckYear++
          if(this.checkYear==this.updateCheckYear){
            this.handleClick()
          }

        });
      }
      const leftButton = document.querySelector('span.h-date-year-left-picker');
      // 检查元素是否存在
      if (leftButton) {
        // 添加点击事件监听
        leftButton.addEventListener('click', () => {
          this.updateCheckYear--;
          if(this.checkYear==this.updateCheckYear){
            this.handleClick()
          }
        });
      }
    },
    getFinishCheckoutDate(){
        if(this.checkoutList && this.checkoutList.length>0){
            this.checkYear = this.checkoutList[0].checkYear;
            this.updateCheckYear = this.checkYear;
            this.finishCheckout = this.checkoutList
                .filter(item => item.status === 2) // 筛选 status 为 2
                .map(item => {
                    const formattedDate = `${item.checkDate} 00:00`; // 修改 checkDate 格式
                    return { ...item, checkDate: formattedDate }; // 返回新的对象
                });
        }
    },
    getMonthNameFromDate(date) {
      const monthNames = ['一月', '二月', '三月', '四月', '五月', '六月',
        '七月', '八月', '九月', '十月', '十一', '十二'];
      return monthNames[date.getMonth()]; // 返回月份名称
    },
    showRemark() {
      const layerId = layer.open({
        title: '记事本',
        zIndex: 999,
        area: ['600px', '600px'],
        content: h(RemarkModal, {
          accountSetsId: this.currentAccountSets.id,
          accountDate: this.currentAccountDate,
          onClose: () => {
            layer.close(layerId);
          }
        })
      });
    },
  }
};
</script>
<style lang="less">

.h-datetime-input-border .h-input {
  width: 100%;
  height: 34px;
}

.app-header {
  color: rgba(49, 58, 70, 0.8);

  .h-autocomplete {
    line-height: 1.5;
    float: left;
    margin-top: 15px;
    margin-right: 20px;
    width: 120px;

    &-show, &-show:hover, &-show.focusing {
      outline: none;
      box-shadow: none;
      border-color: transparent;
      border-radius: 0;
    }

    &-show.focusing {
      border-bottom: 1px solid #eee;
    }
  }

  &-info &-icon-item {
    cursor: pointer;
    display: inline-block;
    float: left;
    padding: 0 15px;
    height: @layout-header-height;
    line-height: @layout-header-height;
    margin-right: 10px;

    &:hover {
      background: @hover-background-color;
    }

    i {
      font-size: 18px;
    }

    a {
      color: inherit;
    }

    .h-badge {
      margin: 20px 0;
      display: block;
    }
  }

  .app-header-icon-item {
    margin-left: 20px;

    button {
      background-color: #ffffff;
    }
  }

  &-dropdown {
    float: right;
    padding: 0 5px 0 5px;

    .h-icon-down {
      right: 20px;
    }

    cursor: pointer;

    &:hover, &.h-pop-trigger {
      background: @hover-background-color;
    }

    &-dropdown {
      padding: 5px 0;

      .h-dropdownmenu-item {
        padding: 8px 20px;
      }
    }
  }

  &-menus {
    display: inline-block;
    vertical-align: top;

    > div {
      display: inline-block;
      font-size: 15px;
      padding: 0 25px;
      color: @dark-color;

      &:hover {
        color: @primary-color;
      }

      + div {
        margin-left: 5px;
      }

      &.h-tab-selected {
        color: @white-color;
        background-color: @primary-color;
      }
    }
  }
}

.as-icon-calendar {
  border: 1px solid #d3d3d3 !important;
  border-left: none !important;
  border-radius: 0 5px 5px 0 !important;
  height: 34px !important;

  &:before {
    vertical-align: middle;
  }
}

.d-input {
  height: 34px !important;
  width: 96px !important;
  padding-right: 0 !important;
  border-right: none !important;
  border-radius: 5px 0 0 5px !important;
}

.h-avatar-info {
  padding-left: 38px !important;
}

.remark-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0 12px;
  height: 34px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  cursor: pointer;
  background-color: #ffffff;
  transition: all 0.2s;
  color: rgba(49, 58, 70, 0.8);
  font-size: 14px;

  &:hover {
    background-color: #f5f5f5;
    border-color: #1E40AF;
  }

  i {
    color: rgba(49, 58, 70, 0.8);
  }

  span {
    color: rgba(49, 58, 70, 0.8);
  }
}
</style>
